import { css } from 'lit';

export const styles = css`
  :host { --header-h: 60px; }

  .pm-page {
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    background: var(--sl-color-neutral-0);
    overflow: hidden; /* only table area scrolls */
  }

  /* Sticky header with filters */
  .page-header {
    background: var(--sl-color-neutral-0);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 1rem;
    position: sticky;
    top: 0;
    z-index: 5;
  }

  .header-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: .75rem;
  }

  .view-toggle {
    display: flex;
    gap: 0.5rem;
  }

  /* Table area */
  .table-wrapper {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding-top: var(--header-h);      /* push below sticky header */
    scroll-padding-top: var(--header-h);
  }


  /* Calendar full view */
  .calendar-full-view {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: var(--sl-color-neutral-0);
  }

  .calendar-header {
    background: var(--sl-color-neutral-0);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 1rem;
    position: sticky;
    top: 0;
    z-index: 5;
    flex-shrink: 0;
  }

  .calendar-container {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  /* Override main content padding for calendar view */
  :host(.calendar-mode) {
    margin: -1.5rem;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
  }

  :host(.calendar-mode) .calendar-full-view {
    width: 100%;
    height: 100%;
  }

  /* Mobile responsive */
  @media (max-width: 768px) {
    .header-actions {
      flex-direction: column;
      align-items: stretch;
      gap: 0.5rem;
    }

    .form-row {
      flex-direction: column;
      gap: 0;
    }
  }
`;